<template>
  <v-img
    :alt="hero.title"
    :src="imageDir + hero.imageNameSmall"
    :srcset="
      `${imageDir + hero.imageNameSmall} 100w,
      ${imageDir + hero.imageNameLarge} 200w`"
    sizes="(max-width: 32rem) 100px, 200px"
    width="100%"
    height="28rem"
    class="hero">
    <v-slide-y-reverse-transition>
      <div
        v-if="!loading && showHeroText"
        class="hero__content"
        :style="`color: ${hero.textColor || '#f0f1f2'}`"
        :class="{
          'hero__content--align-left': hero.alignContent === 'left',
          'hero__content--align-center': hero.alignContent === 'center',
          'hero__content--align-right': hero.alignContent === 'right'
        }">
        <h2
          v-if="hero.title"
          class="hero__title">
          {{ hero.title }}
        </h2>
        <p
          v-if="hero.subtitle"
          class="hero__subtitle">
          {{ hero.subtitle }}
        </p>
        <v-btn
          v-if="hero.ctaText"
          :to="{
            path: hero.ctaPath
          }"
          class="primary hero__cta-button">
          {{ hero.ctaText }}
        </v-btn>
      </div>
    </v-slide-y-reverse-transition>
    <!-- if loading -->
    <div
      v-if="loading"
      class="hero__content hero__content--loading">
      <!-- vuetify button used to create loading icon -->
      <v-progress-circular
        size="100"
        indeterminate
        color="primary" />
    </div>
  </v-img>
</template>

<script>
import api from '../../utils/api';

import defaultHero from '../../assets/images/landing-shot.jpg';

export default {
  name: 'Hero',
  data() {
    return {
      // imageDir: process.env.VUE_APP_BASE_URI + '/marketing/',
      imageDir: '',
      loading: true,
      showHeroText: false,
      defaultHero,
      hero: {
        // default values for fail-to-load
        imageNameLarge: defaultHero,
        imageNameSmall: defaultHero,
        title: '',
        subtitle: '',
        textColor: '#ffffff',
        ctaText: '',
        ctaPath: '/',
        alignContent: 'center',
      },
    };
  },
  created() {
    this.loading = true;
    api
      .getData('/storefront/')
      .then((res) => {
        this.imageDir = `${process.env.VUE_APP_BASE_URI}/images/marketing/`;
        this.hero = res.data.hero;
        this.loading = false;
        setTimeout(() => {
          this.showHeroText = true;
        }, 500);
      })
      .catch(() => {
        this.loading = false;
        setTimeout(() => {
          this.showHeroText = true;
        }, 500);
      });
  },
};
</script>

<style lang="stylus" scoped>
@require('../../stylus/base')

.hero
  color: $secondary
  background-color: $secondary

.hero__content
  display: flex
  flex-flow: column nowrap;
  align-items: center
  justify-content: center
  text-align: center

  height: 100%;
  width: 100%

  padding: $base-padding*4

  &__title
    text-align: inherit

  @media screen and (min-width: 32rem)
    &--align-left
      align-items: flex-start
      text-align: left
    &--align-center
      align-items: center
      text-align: center
    &--align-right
      align-items: flex-end
      text-align: right

  &--loading
    align-items: center
    background-color: $white


.hero__title
  text-shadow: $base-text-shadow

.hero__subtitle
  text-shadow: $base-text-shadow

.hero__cta-button
  margin: 0

</style>
